import { Injectable } from '@angular/core'
import { NativeAppBridgeService } from '@services/native-app-bridge.service'

/** Download grande em rede móvel: a casca confirma o recebimento na hora, mas o resultado pode demorar. */
const NATIVE_DOWNLOAD_TIMEOUT_MS = 120_000

/**
 * Abre documentos no visualizador do aparelho (spec 058). O WebView do app não pré-visualiza PDF, então a casca baixa a
 * URL assinada e abre o arquivo: no Android pelo app de PDF padrão, no iOS pelo QuickLook.
 */
@Injectable({
	providedIn: 'root'
})
export class NativeDocumentService {
	constructor(private bridge: NativeAppBridgeService) {}

	/** Há casca para abrir o documento; fora do app (web), quem chama mantém o modal. */
	get available(): boolean {
		return this.bridge.available
	}

	/** Resolve `true` quando a casca confirma que baixou e abriu; `false` em erro, timeout ou fora do app. */
	async openPdf(preSignedUrl: string, fileName: string): Promise<boolean> {
		try {
			const result = await this.bridge.request(
				'downloadPresignUrl',
				{ url: preSignedUrl, fileName },
				{
					responseType: 'nativePdfDownloadStatus',
					// A casca responde `received` assim que recebe, para o script injetado parar de reenviar.
					accept: message => message['status'] !== 'received',
					timeoutMs: NATIVE_DOWNLOAD_TIMEOUT_MS
				}
			)

			return result['status'] === 'success'
		} catch {
			return false
		}
	}
}
